const group = {
  state: {
    groupId: 0,
    groupName: ''
  },
  mutations: {
    setGroupId: (state, groupId) => {
      state.groupId = groupId
    },
    setGroupName: (state, groupName) => {
      state.groupName = groupName
    }
  },
  actions: {

  }
}

export default group
